/**
 * Messages de la page d'accueil
 */

module.exports = {

    // Demande de congés reçus par un manager
    requestedHolidays: {
        title: 'Congés',
        button: {
            label: 'Accéder aux demandes'
        }
    },

    // Congés restant pour un agent
    remainingHolidays: {
        internal: {
            title: 'Congés',
            counter: 'Aucun congé restant | { count } congé restant | { count } congés restants',
            requestButton: {
                label: 'Demander des congés'
            },
            requestModal: {
                create: {
                    title: 'Faire une demande de congés'
                },
                edit: {
                    title: 'Éditer une demande de congés'
                },
                introduction: 'Si vous souhaitez prendre plusieurs congés non consécutifs, veuillez faire une demande par période.'
            }
        },
        external: {
            title: 'Absences',
            requestButton: {
                label: 'Signaler une absence'
            },
            requestModal: {
                create: {
                    title: 'Faire une demande d\'absence'
                },
                edit: {
                    title: 'Éditer une demande d\'absence'
                },
                introduction: 'Si vous souhaitez prendre plusieurs absences non consécutives, veuillez faire une demande par période.'
            }
        }
    },

    // Gestion du calendrier d'un manager
    manager: {
        agents: {
            loadingError: 'Une erreur s\'est produite pendant le chargement des agents.',
            list: {
                title: 'Agents',
                filter: {
                    title: 'Agents à filtrer',
                    button: {
                        label: 'Filtrer',
                        altLabel: 'Filtrer les agents'
                    }
                },
                addAgent: {
                    button: {
                        label: 'Ajouter un agent'
                    }
                },
                consultRequestedHolidays: {
                    button: {
                        label: 'Demandes',
                        altLabel: 'Consulter les demandes de congés.'
                    }
                }
            }
        }
    },

    // Gestion de la page d'accueil du client
    customer: {
        tasks: {
            title: 'Consulter mon planning de publications',
            altTitle: 'Consulter votre planning de publication.',
            description: 'Visualiser, éditer et valider !'
        },
        publicationSuggestions: {
            title: 'Trouver des idées de publications',
            altTitle: 'Créer une nouvelle tâche.',
            description: 'Créer sans idée !'
        },
        creditsSubscription: {
            title: 'Mon abonnement et mes crédits',
            altTitle: 'Gérer votre abonnement et acheter des crédits.',
            description: 'Souscrire ou modifier !'
        },
        horseChestnutEvent: {
            title: 'Consulter les prochains marronniers',
            altTitle: 'Consulter le planning des prochains événements.',
            description: 'Créer à partir d\'un marronnier !'
        }
    }
};
